"use client"

import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

function Slider({
  className,
  defaultValue,
  value,
  min = 0,
  max = 100,
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Root>) {
  const _values = React.useMemo(
    () =>
      Array.isArray(value)
        ? value
        : Array.isArray(defaultValue)
          ? defaultValue
          : [min, max],
    [value, defaultValue, min, max]
  )

  return (
    <SliderPrimitive.Root
      data-slot="slider"
      defaultValue={defaultValue}
      value={value}
      min={min}
      max={max}
      className={cn(
        "cy:relative cy:flex cy:w-full cy:touch-none cy:items-center cy:select-none cy:data-[disabled]:opacity-50 cy:data-[orientation=vertical]:h-full cy:data-[orientation=vertical]:min-h-44 cy:data-[orientation=vertical]:w-auto cy:data-[orientation=vertical]:flex-col",
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track
        data-slot="slider-track"
        className={cn(
          "cy:bg-muted cy:relative cy:grow cy:overflow-hidden cy:rounded-full cy:data-[orientation=horizontal]:h-3 cy:data-[orientation=horizontal]:w-full cy:data-[orientation=vertical]:h-full cy:data-[orientation=vertical]:w-1.5"
        )}
      >
        <SliderPrimitive.Range
          data-slot="slider-range"
          className={cn(
            "cy:bg-primary cy:absolute cy:data-[orientation=horizontal]:h-full cy:data-[orientation=vertical]:w-full"
          )}
        />
      </SliderPrimitive.Track>
      {Array.from({ length: _values.length }, (_, index) => (
        <SliderPrimitive.Thumb
          data-slot="slider-thumb"
          key={index}
          className="cy:border-white cy:bg-primary cy:ring-ring/50 cy:block cy:size-6 cy:shrink-0 cy:rounded-full cy:border-3 cy:shadow-md cy:transition-[color,box-shadow] cy:hover:ring-4 cy:focus-visible:ring-4 cy:focus-visible:outline-hidden cy:disabled:pointer-events-none cy:disabled:opacity-50"
        />
      ))}
    </SliderPrimitive.Root>
  )
}

export { Slider }
